import type { AuthVariant } from "./authVariants";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

type Props = {
  variant: AuthVariant;
};

export const AuthSidePanel = ({ variant }: Props) => {
  return (
    <div className="relative z-10 max-w-lg text-white p-12">
      <div className="mb-10">
        <h1 className="text-4xl lg:text-5xl font-bold mb-4 leading-tight">
          {variant.headline}
        </h1>
        <p className="text-xl text-white/90 leading-relaxed">{variant.sub}</p>
      </div>

      {variant.layout === "cards" && variant.items && (
        <div className="space-y-6">
          {variant.items.map((item) => (
            <div key={item.title} className="flex items-start space-x-4">
              <div className="w-12 h-12 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0 mt-1">
                <GenieIcon name={item.genieIcon} size={24} color="#ffffff" label={item.title} />
              </div>
              <div>
                <h3 className="text-lg font-bold mb-1">{item.title}</h3>
                <p className="text-white/90 leading-relaxed">{item.body}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {variant.layout === "proof" && variant.proof && (
        <div className="space-y-6">
          <div className="rounded-2xl bg-white/15 backdrop-blur-sm border border-white/20 p-6">
            <p className="text-lg font-medium text-white leading-relaxed">
              {variant.proof.stat}
            </p>
          </div>
          <p className="text-xl text-white/90 italic">"{variant.proof.tagline}"</p>
        </div>
      )}
    </div>
  );
};
